import type { LeagueConfig } from '@leagueplatform/core';
import {
  commonCoreConfig,
  commonCoreAuthClientOptionsDomain,
  commonCoreAuthClientOptionsClientId,
  commonCoreAuthClientOptionsRedirectUri,
  viteAppEnvironment,
} from './common/core';
import { EN_CONFIG_APP_STRINGS } from './strings';

export const DISCOVERY_AUDIENCE = 'https://multi-tenant-cact/api';

/**
 * Auth0 config used during the discovery login phase, before a tenant is selected.
 *
 * Intentionally omits `organization` so Auth0 domain discovery can infer the
 * user's accessible orgs from their email domain. The `audience` points to a
 * dummy resource server whose only purpose is to carry the `accessible_tenants`
 * custom claim in the returned token — it does not grant access to any tenant backend.
 *
 * `contentUrl` and `api` are unused during the discovery phase (no tenant API
 * calls are made before a tenant is selected), so they are set to empty strings.
 */
export const discoveryConfig: LeagueConfig = {
  core: {
    ...commonCoreConfig,
    appEnvironment: viteAppEnvironment,
    contentUrl: '',
    api: {
      url: '',
      wsUrl: '',
      legacyRestApi: '',
    },
    auth: {
      clientOptions: {
        domain: commonCoreAuthClientOptionsDomain,
        client_id: commonCoreAuthClientOptionsClientId,
        redirect_uri: commonCoreAuthClientOptionsRedirectUri,
        audience: DISCOVERY_AUDIENCE,
        useRefreshTokens: true,
      },
      idleSessionLifetimeHours: 1,
    },
    i18n: {
      strings: {
        default: EN_CONFIG_APP_STRINGS,
        en: EN_CONFIG_APP_STRINGS,
      },
    },
  },
};
